(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["raftee-purchase-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('raftee-purchase-options')) {
  customElements.define('raftee-purchase-options', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.handleChange = () => this.update();
      this.handleSubmit = () => this.update();
      this.form?.addEventListener('submit', this.handleSubmit, true);
      this.form?.addEventListener('change', this.handleChange);
      this.form?.addEventListener('input', this.handleChange);
      this.update();
    }
    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.handleSubmit, true);
      this.form?.removeEventListener('change', this.handleChange);
      this.form?.removeEventListener('input', this.handleChange);
    }
    update() {
      const selected = this.querySelector('input[name="selling_plan"]:checked');
      const info = this.querySelector('.raftee-subscription-info');
      if (info) info.hidden = false;
      const intro = this.querySelector('[data-subscription-intro]');
      if (intro) intro.hidden = Boolean(selected?.value);
      const quantityInput = this.form?.querySelector('[name="quantity"]');
      const quarterly = selected?.dataset.orderQuantity === '3';
      if (quantityInput) {
        if (quarterly) {
          if (!this.quarterly) this.previousQuantity = quantityInput.value;
          quantityInput.value = '3';
          quantityInput.readOnly = true;
        } else if (this.quarterly) {
          quantityInput.value = this.previousQuantity || '1';
          quantityInput.readOnly = false;
        }
        quantityInput.closest('.quantity')?.querySelectorAll('button').forEach(button => button.disabled = quarterly);
      }
      this.quarterly = quarterly;
      const quantity = quarterly ? 3 : Math.max(1, Number(quantityInput?.value) || 1);
      this.querySelectorAll('[data-plan-notice]').forEach(notice => {
        notice.hidden = notice.dataset.planNotice !== selected?.value;
        const charge = notice.querySelector('[data-charge]');
        if (charge) charge.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency', currency: this.dataset.currency || 'USD'
        }).format(Number(notice.dataset.unitPrice) * quantity / 100);
      });
      const buttonPrice = this.form?.querySelector('.add-to-cart-button .product-price');
      if (buttonPrice && selected) buttonPrice.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: this.dataset.currency || 'USD'
      }).format(Number(selected.dataset.unitPrice) * quantity / 100);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
